import { render, staticRenderFns } from "./OrderCardItem.vue?vue&type=template&id=79ae91fe&scoped=true"
import script from "./OrderCardItem.vue?vue&type=script&lang=js"
export * from "./OrderCardItem.vue?vue&type=script&lang=js"
import style0 from "./OrderCardItem.vue?vue&type=style&index=0&id=79ae91fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae91fe",
  null
  
)

export default component.exports